import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enableSpinner: false,
  spinnerText: "",
  versionData: {},
  envData: "",
  error: {},
  downloadData: "",
};

const documentMetaSlice = createSlice({
  name: "documents/meta",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_DOWNLOAD_CLICK", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.error = p.error;
      })
      .addCase("ON_GENERATING_COPY_LINKS", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.enableSpinner = p.state;
        state.error = p.error;
      })
      .addCase("ON_DOCUMENT_DOWNLOAD", (state, action) => {
        state.enableSpinner = action.payload;
        if (action.payload !== true) state.spinnerText = "";
      })
      .addCase("ON_SET_VERSION_DETAILS", (state, action) => {
        state.versionData = action.payload;
      })
      .addCase("ON_SET_IFS_ENV_DETAILS", (state, action) => {
        state.envData = action.payload;
        state.error = action.payload.error;
      })
      .addCase("ON_VIWE_DOCUMENT_WEB", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.enableSpinner = p.state;
        state.error = p.error;
      })
      .addCase("ON_SPINNER_TEXT_CHANGE", (state, action) => {
        state.spinnerText = action.payload;
      });
  },
});

export default documentMetaSlice.reducer;
